package com.example.mystybag.common.ui.views

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.systemBars
import androidx.compose.material3.FabPosition
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.core.logic.base.BottomSheetChild
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.common.extensions.Zero

@Composable
fun <S: Any, T: ChildViewModel<S>> ModalBottomSheetUIView(
    viewModel                   : T,
    modifier                    : Modifier                                  = Modifier,
    horizontalAlignment         : Alignment.Horizontal                      = Alignment.CenterHorizontally,
    verticalArrangement         : Arrangement.Vertical                      = Arrangement.Top,
    floatingActionButton        : @Composable () -> Unit                    = {},
    floatingActionButtonPosition: FabPosition                               = FabPosition.End,
    removeVerticalPadding       : Boolean                                   = false,
    bottomSheetFactory          : @Composable (BottomSheetChild) -> Unit    = {},
    navigationContent           : @Composable (() -> Unit)?                 = null,
    screenContent               : @Composable ColumnScope.(State<S>) -> Unit
) {

    UIView(
        viewModel                    = viewModel,
        modifier                     = modifier,
        horizontalAlignment          = horizontalAlignment,
        verticalArrangement          = verticalArrangement,
        floatingActionButton         = floatingActionButton,
        floatingActionButtonPosition = floatingActionButtonPosition,
        removeVerticalPadding        = removeVerticalPadding,
        navigationContent            = navigationContent
    ) {
        screenContent(it)
    }

    ModalBottomSheetView(
        sheetControl        = viewModel,
        bottomSheetFactory  = bottomSheetFactory
    )
}

@Composable
fun <S: Any, T: ChildViewModel<S>> BottomSheetUIView(
    viewModel                   : T,
    modifier                    : Modifier                                  = Modifier,
    horizontalAlignment         : Alignment.Horizontal                      = Alignment.CenterHorizontally,
    verticalArrangement         : Arrangement.Vertical                      = Arrangement.Top,
    floatingActionButton        : @Composable () -> Unit                    = {},
    floatingActionButtonPosition: FabPosition                               = FabPosition.End,
    removeVerticalPadding       : Boolean                                   = false,
    applyBottomInsetSpacer      : Boolean                                   = true,
    removeBottomSheetPadding    : Boolean                                   = false,
    windowInsets                : WindowInsets                              = if (removeVerticalPadding) WindowInsets.Zero else WindowInsets.systemBars,
    statusBarContent            : @Composable ((Modifier) -> Unit)?         = null,
    bottomSheetFactory          : @Composable (BottomSheetChild) -> Unit    = {},
    navigationContent           : @Composable (() -> Unit)?                 = null,
    showTopBar                  : Boolean                                   = true,
    screenContent               : @Composable ColumnScope.(State<S>) -> Unit
) {
    BottomSheetLayoutView(
        sheetControl                = viewModel,
        bottomSheetFactory          = bottomSheetFactory,
        removeBottomSheetPadding    = removeBottomSheetPadding,
    ) {
        UIView(
            viewModel                    = viewModel,
            modifier                     = modifier,
            horizontalAlignment          = horizontalAlignment,
            verticalArrangement          = verticalArrangement,
            floatingActionButton         = floatingActionButton,
            floatingActionButtonPosition = floatingActionButtonPosition,
            removeVerticalPadding        = removeVerticalPadding,
            windowInsets                 = windowInsets,
            statusBarContent             = statusBarContent,
            navigationContent            = navigationContent,
            showTopBar                   = showTopBar,
            applyBottomInsetSpacer       = applyBottomInsetSpacer,
            content                      = screenContent
        )
    }
}

/*@Preview(showSystemUi = true)
@Composable
fun BottomSheetPreview() {
    AppTheme.setup(false)
    AppThemeView {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.current.colors.surface)
                .height(p36)
        ) {
            Box(modifier = Modifier
                .fillMaxWidth()
                .background(Color.Black),
                contentAlignment = Alignment.Center
            ) {
                Divider(
                    modifier = Modifier
                        .padding(top = p4XS, bottom = pS)
                        .size(width = p22, height = p6XS)
                        .clip(RoundedCornerShape(p03)),
                        //.align(Alignment.CenterHorizontally),
                    color = AppTheme.current.colors.background.copy(alpha = 0.2f),
                    thickness = p6XS
                )
            }
        }
    }
}*/
